/**
 * Routes that work without a session. App.jsx's boot-time session check must
 * not bounce these to /login: a parent scanning a School Bus QR, a driver opening the roll-call link (/drive/) or a customer
 * opening a /share link or a public Wall link (/w/) has no account and never will. Keep in step with the
 * "Public" block at the top of Router.jsx.
 */
const PUBLIC_EXACT = new Set(['/login', '/register', '/verify', '/wall']);
const PUBLIC_PREFIXES = ['/share/', '/bus/', '/family/', '/drive/', '/verify/', '/w/'];

export function isPublicPath(pathname) {
  if (PUBLIC_EXACT.has(pathname)) return true;
  return PUBLIC_PREFIXES.some((p) => pathname.startsWith(p) && pathname.length > p.length);
}
